<template>
	<div
		data-testid="search-field-component"
		class="ui input"
	>
		<span
			v-show="Object.entries(help).length > 0"
			class="message__help__inputsearch"
			:class="help.type"
			>{{ help.message }}</span
		>
		<input
			class="form-input"
			type="text"
			:placeholder="placeholder != null ? placeholder : label"
			:value="value"
			@input="changeValue($event)"
		/>

		<i
			v-if="value"
			class="fas fa-times-circle icon"
			@click="cleanValue"
		/>
		<i
			v-else
			class="fas fa-search icon emptyInput"
		/>
	</div>
</template>

<script>
export default {
	props: {
		help: {
			type: Object,
			default: () => {
				return { type: '', message: '' }
			},
		},
		placeholder: String,
		value: String,
		label: String,
	},
	methods: {
		changeValue(e) {
			this.$emit('input', e.target.value)
		},
		cleanValue() {
			this.$emit('input', '')
		},
	},
}
</script>

<style scoped>
.ui.input {
	flex-direction: column-reverse;
	width: 100%;
	position: relative;
	margin: 0;
}

.ui.input .form-input {
	font-size: 0.75rem;
	border-radius: 3px !important;
	border: 1px solid rgba(var(--color-primary), 0.3);
}

.form-label {
	font-size: 0.75rem;
}

.icon {
	position: absolute;
	right: 0.5rem;
	top: 0.55rem;
	height: 100%;
	color: var(--color-gray);
}

.emptyInput {
	color: rgb(var(--color-default));
}

.message__help__inputsearch.warning {
	background-color: transparent !important;
	color: var(--color-warning-background) !important;
}
</style>
